'use client';
import useStableCallback from '@/hooks/use-stable-callback';
import { useSearchParams } from 'next/navigation';
import { useRouter } from '@/hooks/use-router';

// Client side logic to set and redirect to the callback URL
// Logic not kept only on server to prevent extra network call

export function getCallbackRedirectUrl() {
  const search = new URLSearchParams(window.location.search);
  const callbackUrl = search.get('callbackUrl') || '/';
  return new URL(callbackUrl, window.location.origin);
}

export function useRedirectToCallbackUrl() {
  const search = useSearchParams();
  const router = useRouter();

  return useStableCallback(() => {
    const callbackUrl = search.get('callbackUrl') || '/';
    router.replace(callbackUrl);
  });
}

export function useSetCallbackUrlAndRedirect() {
  const router = useRouter();

  return useStableCallback((redirectPath: string) => {
    const redirectUri =
      window.location.pathname + window.location.search + window.location.hash;

    const url = new URL(redirectPath, window.location.origin);
    url.searchParams.set('callbackUrl', redirectUri);

    router.replace(url.toString());
  });
}
